module.exports = __webpack_public_path__ + "media/images/metronic/social/last-fm-3e11a5fa38ba1d38e0bf72560d693aba.png";